import React, { useState } from 'react'
import { getUserData } from '../../../../Utils/localStorageUtils';
import useCustomNavigate from '../../../../hooks/useCustomNavigate';
import { useToast } from '../../../../hooks/useToast';
import { addInterestedUser } from '../../../../services/propertyService';


const maskPhoneNumber = (phone) => {
  if (!phone || phone.length < 10) return "XXXXXXXXXX";
  return phone.replace(/(\d{2})(\d{8})/, "$1XXXXXXXX");
};


const RightSection = ({ postedByData ,propertyId}) => {

  const { name = "Unknown", mobile = "", role = "Owner" } = postedByData || {};

  console.log("postedByData",postedByData)

  const {goTo} = useCustomNavigate()
  const { showSuccess, showError } = useToast()
 
  const userData = getUserData();
  const [showFullNumber, setShowFullNumber] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  console.log("userData",userData)


  const handleClick = async() => {
    if (!userData) {
      goTo('/login');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await addInterestedUser(propertyId, userData._id);;
       console.log("response",response)
      if (response.success) {
        setShowFullNumber(true);
        showSuccess("Request Sent Successfully!");
      } else {
        setError(response.message || "Something went wrong");
        showError(response.message || "Failed to send request");
        setShowFullNumber(true);
      }
    } catch (err) {
      setError("Internal Server Error");
      showError("Internal Server Error");
    } finally {
      setLoading(false);
    }


  };



  return (
    <div className='h-auto  p-4 md:p-[24px] border border-[#d7d7d7] rounded-[8px] bg-white shadow-lg w-full max-w-md mx-auto'>
      <h1 className='text-[#303030] text-base md:text-[18px] font-semibold mb-3'>
        Contact Owner
        {/* Contact {role.charAt(0).toUpperCase() + role.slice(1)} */}
      </h1>
      <h3 className='text-[#303030] text-[16px] capitalize font-semibold leading-[20px] mb-3'>{name}{" "}

        <span className='text-[#303030] text-[12px] font-normal'>
        {`+91- ${showFullNumber ? mobile : maskPhoneNumber(mobile)}`}

        </span></h3>
        <button 
        
        className='bg-[#2b463c] leading-[44px] text-[14px] text-[#fff] w-full h-[44px] rounded-[22px] font-semibold'
        onClick={handleClick}
        disabled={loading}
        >
         {/* { userData ? "Request Sent" : "Get Phone No."} */}
         {loading ? "Processing..." : userData ? "Request Sent and Show Number" : "Get Phone No."}
        </button>
        {error && <p className='text-red-500 mt-2'>{error}</p>}
    </div>
  )
}

export default RightSection
